import React from 'react';

/*
 * MonitorToolbar — the shared 2-row filter/command bar for the Event Monitor's two
 * feeds (Events + User Log). Defined ONCE here so the two screens stay identical and
 * can't drift; each screen only supplies its own controls through the slots below.
 *
 *   Row 1 (top):     [ search ] [ type chips ] ······· grow ······· [ actionsTop ]
 *   Row 2 (bottom):  [ date + location selects ] ····· grow ······· [ actionsBottom ]
 *
 * The layout/spacing lives in .toolbar / .toolbar__row (TransactionMonitor.css); the
 * DateFilter's own fixed width keeps the row-2 filters from shifting. Slots that don't
 * apply to a screen (e.g. User Log has no Export) are just left undefined.
 */
export default function MonitorToolbar({ search, chips, actionsTop, filters, actionsBottom }) {
  return (
    <div className="toolbar">
      <div className="toolbar__row toolbar__row--top">
        { search }
        { chips }
        <div className="grow" />
        { actionsTop }
      </div>
      <div className="toolbar__row toolbar__row--bottom">
        { filters }
        <div className="grow" />
        { actionsBottom }
      </div>
    </div>
  );
}
